import { clone, } from '../../helpers/';
import { DEFAULT_JOURNEY_ID } from '../../constants';
import types from '../types';

const initialState = {
    page : "home"
};

const pageReducer = function(state = initialState, action) {
	let stateClone = clone(state);

	switch(action.type) {

		case "SET_PAGE": 
			stateClone.page = action.page;
			break;
	}

	return stateClone;
};

export default pageReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/page.ts